import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {
  BrowserModule,
  provideClientHydration,
} from '@angular/platform-browser';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { FormsModule } from '@angular/forms';
// import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import player from 'lottie-web';
// import { LottieModule } from 'ngx-lottie';
// import { NgImageSliderModule } from 'ng-image-slider';
import {} from 'swiper/';
import { AppRoutingModule } from './app-routing.module';
import { AppJobModule } from './app-job/app-job.module';
import { AppToolsModule } from './app-tools/app-tools.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
// import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatButtonModule } from '@angular/material/button';
// import { MatGridListModule } from '@angular/material/grid-list';
import { MatGridListModule } from '@angular/material/grid-list';
// import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatCardModule } from '@angular/material/card';
// import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
// import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
// import { MatLegacyDialogModule as MatDialogModule, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
// import { MatDialogModule } from '@angular/material/dialog';
// import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
// import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
// import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { NewPageModule } from './new-page/new-page.module';
import { SharedModule } from './shared/shared.module';

import { APIService } from './services/api.service';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { NgxGradientTextComponent } from '@omnedia/ngx-gradient-text';
import { NgxMarqueeComponent } from '@omnedia/ngx-marquee';

export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    // BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserModule,
    AppRoutingModule,

    AppToolsModule,
    AppJobModule,
    BrowserAnimationsModule,
    // LottieModule.forRoot({ player: playerFactory }),
    MatToolbarModule,
    MatIconModule,
    // NgImageSliderModule,
    MatFormFieldModule,
    MatButtonModule,
    MatGridListModule,
    MatCardModule,
    MatTabsModule,
    MatMenuModule,
    MatDialogModule,
    MatInputModule,
    FormsModule,
    MatRadioModule,
    MatSnackBarModule,
    NewPageModule,
    SharedModule,
    NgxGradientTextComponent,
    NgxMarqueeComponent,
  ],
  providers: [
    GoogleAnalyticsService,
    APIService,
    provideHttpClient(withInterceptorsFromDi()),
    provideClientHydration(),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
